// extracted by mini-css-extract-plugin
export default {"con":"index_con__EmR4M","tips":"index_tips__pSNvy"};